export default __webpack_public_path__ + "ca26b38d1744b1ef1ea2c728933d6c59.ttf";